import { loadTranslations } from '@ibk/shared-translation';
import { sharedUiTranslations } from '@ibk/shared-ui';
import enUS from './en-US.json';
import esES from './es-ES.json';
import ptBR from './pt-BR.json';
export const dominioempresaTranslations = loadTranslations({
    'pt-BR': {
        ...sharedUiTranslations['pt-BR'],
        ...ptBR,
    },
    'en-US': {
        ...sharedUiTranslations['en-US'],
        ...enUS,
    },
    'es-ES': {
        ...sharedUiTranslations['es-ES'],
        ...esES,
    },
});
